webpackJsonp([260628236510232],{

/***/ 1218:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0002_young_treant.jpg","type":"Unit","subtype":"Tree","cost":2,"ATK":0,"HP":2,"rules_text_1":"Arrives: Draw a card.","rules_text_2":"Can't attack","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Young Treant","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"To fight a forest, you first have to get through the trees.","color":"Green","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"young_treant"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"young_treant","keywords":[],"imageRegex":"/young_treant.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-young-treant-3f4f896a94c81ffba1a5.js